import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbModalModule, NgbDatepickerModule, NgbActiveModal, NgbTooltipModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { TagInputModule } from 'ngx-chips';
import { ColorPickerModule } from 'ngx-color-picker';
import { ThousandSuffixPipe, SecondsToTimePipe } from './pipes/thousand-suffix.pipe';
import { CommentModal } from './components/commentModal/commentModal.component';
import { AlertModalComponent } from './components/alert-modal/alert-modal.component';
import { PreviewModalComponent } from './components/preview-modal/preview-modal.component';
import { NgDraggableWidgetModule } from 'lib/ngx-draggable-widget/main';
import { DataTableModule } from "angular2-datatable";
import { NgxPaginationModule } from 'ngx-pagination';
// Slider.
import { IonRangeSliderModule } from "ng2-ion-range-slider";
import { MyDateInput } from './components/my-date-input/my-date-input';
import { TreeModule } from 'angular-tree-component';
import { PromptModalComponent } from './components/prompt-modal/prompt-modal.component';
import { MediaPreviewOnRegionComponent } from './components/media-preview-on-region';
import { DemoPreviewOnRegionComponent } from './components/demo-preview-on-region';
import { UserLocationHierarchy } from './components/location-hierarchy';
import { LocationService } from './components/location-hierarchy/services/location-hierarchy.service';
import { IndianDateFormatPipe, Time, DateFormatPipe, DatexPipe, FileSizePipe } from './pipes/date-format.pipe';
import { MediaThumbnailComponent } from './components/media-thumbnail/media-thumbnail.component';
import { FieldErrorMessageComponent } from './components/field-error-message/field-error-message.component';
import { StatusDirective } from './directives';
import { NumericZeroToHundred } from './directives/custom-validators';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap/typeahead/typeahead.module';
import { CampaignPreviewShared } from './components/campaign-preview/campaign-preview.component';
import { PlanogramPreviewComponent } from './components/planogram-preview/planogram-preview.component';
import { CampaignService } from '../cms/components/campaign/services/campaign.service';
import { MediaLibraryServices } from '../cms/components/media-library/services/mediaLibraryServices';
import { ImageCroppingComponent } from './components/image-cropping/image-cropping.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NotificationsList } from './components/notification/notification-list/notification-list.component';
import { NotificationCardComponent } from './components/notification/notification-card/notification-card.component';
import { ClientMessagingComponent } from './components/client-messaging-key-value/client-messaging.component';
// import { NotificationService, FcmMessagingService } from "../../services/index";
import { MinuteSecondsPipe } from '../shared/pipes/second-to-minute.pipe';
import { SharedService } from './services/shared.service';
import { PaginatorTemplate } from './components/paginator-template/paginator-template.component';
import { NgxPaginatorTemplate } from './components/ngx-paginator-template/ngx-paginator-template.component'
import { ChartsModule } from 'ng2-charts';
// import { DoughnutChartComponent } from './components/charts/doughnutChart/doughnutChart.component';
// import { BarChartComponent } from './components/charts/barChart/barChart.component';
// import { LineChartComponent } from './components/charts/lineChart/lineChart.component';
/* stomp start */
import { StompConfig, StompService } from '@stomp/ng2-stompjs';
import { stompConfig } from '../../models/rx-stomp-config';
import { Constants } from '../../app.constant';
import { PushNotificationService } from './services/push-notification.service';
import { CapsulingPreviewComponent } from './components/capsuling-preview/capsuling-preview.component';
import { EncryptionService } from '../../services/encryption.service';

/* stomp end*/

export function stompConfigFactory(stompConfig: StompConfig) {
  stompConfig.url = Constants.setStompConfig('url'),
    stompConfig.headers.login = Constants.setStompConfig('loginName'),
    stompConfig.headers.passcode = Constants.setStompConfig('passcode')
  return stompConfig;

}


// const STOMP_SERVICE=(!Constants.Var.sslOn && stompConfig.url !== null)?[
//   StompService,
//   {
//     provide: StompConfig,
//     useFactory: stompConfigFactory,
//     deps:[stompConfig],
//     multi: true
//   }
// ]: [];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    TagInputModule,
    ColorPickerModule,
    NgDraggableWidgetModule,
    NgbModalModule,
    NgbTooltipModule,
    NgbDropdownModule,
    NgbPopoverModule,
    TreeModule,
    NgbDatepickerModule,
    InfiniteScrollModule,
    NgbTypeaheadModule,
    ImageCropperModule,
    NgbTypeaheadModule,
    IonRangeSliderModule,
    DataTableModule,
    NgxPaginationModule,
    ChartsModule

  ],
  declarations: [
    ThousandSuffixPipe,
    SecondsToTimePipe,
    CommentModal,
    MinuteSecondsPipe,
    AlertModalComponent,
    MyDateInput,
    PreviewModalComponent,
    PromptModalComponent,
    MediaPreviewOnRegionComponent,
    DemoPreviewOnRegionComponent,
    UserLocationHierarchy,
    DateFormatPipe,
    IndianDateFormatPipe,
    Time,
    DatexPipe,
    MediaThumbnailComponent,
    FieldErrorMessageComponent,
    StatusDirective,
    NumericZeroToHundred,
    CampaignPreviewShared,
    PlanogramPreviewComponent,
    ImageCroppingComponent,
    NotificationsList,
    NotificationCardComponent,
    PlanogramPreviewComponent,
    FileSizePipe,
    PaginatorTemplate, NgxPaginatorTemplate,
    ClientMessagingComponent,
    // ,DoughnutChartComponent,
    // BarChartComponent,
    // LineChartComponent
    CapsulingPreviewComponent
  ],
  exports: [
    ThousandSuffixPipe,
    SecondsToTimePipe,
    MinuteSecondsPipe,
    CommonModule,
    TagInputModule,
    ColorPickerModule,
    NgDraggableWidgetModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbPopoverModule,
    FormsModule,
    TreeModule,
    MyDateInput,
    NgbTooltipModule,
    MediaPreviewOnRegionComponent,
    DemoPreviewOnRegionComponent,
    MediaThumbnailComponent,
    FieldErrorMessageComponent,
    UserLocationHierarchy,
    DateFormatPipe, DatexPipe, FileSizePipe, IndianDateFormatPipe, Time,
    StatusDirective,
    InfiniteScrollModule,
    NumericZeroToHundred,
    NgbTypeaheadModule,
    CampaignPreviewShared,
    PlanogramPreviewComponent,
    ImageCroppingComponent,
    NotificationsList,
    NotificationCardComponent,
    PlanogramPreviewComponent,
    DataTableModule, NgxPaginationModule,
    PaginatorTemplate, NgxPaginatorTemplate,
    CapsulingPreviewComponent

  ],
  providers: [
    NgbActiveModal,
    NgbTooltipModule,
    DemoPreviewOnRegionComponent,
    LocationService,
    CampaignService,
    MediaLibraryServices,
    SharedService,
    PushNotificationService,
    EncryptionService
    // NotificationService,
    // FcmMessagingService
  ],
  entryComponents: [
    CommentModal,
    CampaignPreviewShared
  ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/pages/shared/shared.module.ts